if (!customElements.get("product-form")) {
  customElements.define(
    "product-form",
    class ProductForm extends HTMLElement {
      constructor() {
        super();
        this.onSubmitHandler = this.onSubmitHandler.bind(this);
        this.form = this.querySelector("form");
        this.form.querySelector("[name=id]").disabled = false;
        if (!!throttle) this.form.addEventListener("submit", throttle(this.onSubmitHandler, 1000));
        this.cart = document.querySelector("cart-notification") || document.querySelector("cart-drawer");
        this.submitButton = this.querySelector('[type="submit"]');

        if (document.querySelector("cart-drawer") && this.submitButton) {
          this.submitButton.setAttribute("aria-haspopup", "dialog");
        }

        document.addEventListener("DOMContentLoaded", () => {
          document.body.addEventListener("change", (event) => {
            if (event.target && event.target.id == "fp-gift-card-amount") {
              this.unCheckRadio();
            }
          });
        });

        this.hideErrors = this.dataset.hideErrors === "true";
      }

      connectedCallback() {
        this.initSubmitButton();
      }

      unCheckRadio() {
        const giftCardAmount = document.getElementById("fp-gift-card-amount")?.value;
        const amount = giftCardAmount.replace("$", "");
        // If the amount is valid, uncheck radio buttons
        if (!isNaN(amount) && amount >= 50 && amount <= 1000) {
          const radios = document.querySelectorAll('input[name^="Value-1"]'); // Matches any name starting with "Value-1"
          radios.forEach((radio) => {
            radio.checked = false;
          });
        }
      }

      async initSubmitButton() {
        if (!isLocalDev()) {
          try {
            await window.isClerkLoaded(); // NOTE: declared on theme.liquid
          } catch (err) {
            console.error("Clerk load failed", err);
          }
        }
        if (this.submitButton?.name && this.submitButton.name === "add") {
          this.submitButton.removeAttribute("disabled");
        }
      }

      async onSubmitHandler(event) {
        event.preventDefault();
        if (this.submitButton.getAttribute("aria-disabled") === "true") {
          return;
        }

        this.handleErrorMessage();

        this.submitButton.setAttribute("disabled", true);
        this.submitButton.setAttribute("aria-disabled", true);
        this.submitButton.classList.add("loading");
        this.querySelector(".loading__spinner").classList.remove("hidden--important");

        const config = fetchConfig("javascript");
        config.headers["X-Requested-With"] = "XMLHttpRequest";
        delete config.headers["Content-Type"];

        const formData = new FormData(this.form);

        const selectElement = document.getElementById("fp-gift-card-amount");
        const selectedOption = selectElement?.selectedOptions[0];
        const sendAt = formData.get("properties[_gift_send_at]");

        if (sendAt) {
          const now = new Date();
          const sendAtDate = new Date(sendAt);
          if (sendAtDate > now) {
            formData.set("properties[_gift_send_at]", sendAtDate.toISOString().replace(/\.\d{3}Z$/, "-00:00"));
          } else {
            formData.delete("properties[_gift_send_at]");
          }
        }

        if (selectedOption) {
          const giftCardAmount = selectedOption.value;
          const variantId = selectedOption.dataset.variantId;
          if (giftCardAmount) {
            const amount = giftCardAmount.replace("$", "");
            formData.delete("id");
            formData.set("id", variantId);
            formData.append("Value-1\n", `$${amount}`);
          }
        }

        if (this.cart) {
          formData.append(
            "sections",
            this.cart.getSectionsToRender().map((section) => section.id),
          );
          formData.append("sections_url", window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }

        try {
          config.body = formData;
          const responseReq = await fetch(`${routes.cart_add_url}`, config);
          const response = await responseReq.json();
          if (response.key) {
            const giftSendAt = formData.get("properties[_gift_send_at]");
            const recipientName = formData.get("properties[_recipient_name]");
            const recipientEmail = formData.get("properties[_recipient_email]");
            const giftImage = formData.get("properties[_gift_image]");
            const giftMessage = formData.get("properties[_gift_message]");

            processAddingItem({
              epi: response.variant_id,
              empi: response.product_id,
              du: this.submitButton.getAttribute("data-product-url"),
              qty: response.quantity,
              cprops: {
                ...(giftSendAt ? { _gift_send_at: giftSendAt } : {}),
                ...(recipientName ? { _recipient_name: recipientName } : {}),
                ...(recipientEmail
                  ? {
                      _recipient_email: recipientEmail,
                      _custom_epi: `${response.variant_id} custom`,
                      _custom_empi: `${response.product_id} custom`,
                    }
                  : {}),
                ...(giftImage ? { _gift_image: giftImage } : {}),
                ...(giftMessage ? { _gift_message: giftMessage } : {}),
              },
              ...(recipientEmail ? { price: response.price } : {}),
              ...(recipientEmail ? { key: response.key } : {}),
            });
          }
          if (response.status) {
            publish(PUB_SUB_EVENTS.cartError, {
              source: "product-form",
              productVariantId: formData.get("id"),
              errors: response.errors || response.description,
              message: response.message,
            });
            this.handleErrorMessage(response.description);

            const soldOutMessage = this.submitButton.querySelector(".sold-out-message");
            if (!soldOutMessage) {
              return;
            }
            this.submitButton.querySelector("span").classList.add("hidden--important");
            soldOutMessage.classList.remove("hidden--important");
            this.error = true;
            return;
          } else if (!this.cart) {
            window.location = window.routes.cart_url;
            return;
          }
          if (!this.error) {
            publish(PUB_SUB_EVENTS.cartUpdate, {
              source: "product-form",
              productVariantId: formData.get("id"),
              cartData: response,
            });
            // NOTE: Update the submit button's data-quantity attribute value if the item was added to the cart successfully.
            // This value is used in the persisted cart feature.
            const currentDataQuantity = this.submitButton.getAttribute("data-quantity");
            const recipientEmail = formData.get("properties[_recipient_email]");
            if (recipientEmail) return; // Do nothing if, _recipient_email property is present.
            this.submitButton.setAttribute("data-quantity", Number(currentDataQuantity ?? 0) + 1);
          }
          this.error = false;
          const quickAddModal = this.closest("quick-add-modal");
          if (quickAddModal) {
            document.body.addEventListener(
              "modalClosed",
              () => {
                setTimeout(() => {
                  this.cart.renderContents(response);
                });
              },
              { once: true },
            );
            quickAddModal.hide(true);
          } else {
            this.cart.renderContents(response);
          }
        } catch (error) {
          console.error(error);
        } finally {
          this.submitButton.classList.remove("loading");
          toggleCartLoader("hide");
          if (this.cart && this.cart.classList.contains("is-empty")) this.cart.classList.remove("is-empty");
          if (!this.error) {
            this.submitButton.removeAttribute("disabled");
            this.submitButton.removeAttribute("aria-disabled");
          }
          this.querySelector(".loading__spinner").classList.add("hidden--important");
        }
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector(".product-form__error-message-wrapper");
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector(".product-form__error-message");

        this.errorMessageWrapper.toggleAttribute("hidden", !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      getCart() {
        return fetch("/cart.js")
          .then((response) => {
            if (!response.ok) {
              throw new Error("Failed to fetch cart");
            }
            return response.json();
          })
          .then((data) => data)
          .catch((error) => {
            console.error("Cart fetch error:", error);
            return null;
          });
      }
    },
  );
}
